import { Component, inject } from '@angular/core';
import { ChangesService } from '../../../../services/changes.service';
import { JsonPipe } from '@angular/common';
import { CustomResponse } from '../../../../interfaces/custom-response.model';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-changes',
  standalone: true,
  imports: [JsonPipe, DividerModule],
  templateUrl: './changes.component.html',
  styleUrl: './changes.component.css'
})
export class ChangesComponent {

  changeService = inject(ChangesService);

  changes: any = [];
  loading: boolean = false;

  constructor() {
    this.loading = true;
    this.changeService.getChanges().subscribe((response: CustomResponse) => {
      if (response.success == 1) {
        this.changes = response.data;
        this.loading = false;
      }
    });
  }
}
